const pricing = {
  // HeroSection
  'pricing.hero.homeLink': 'Home',
  'pricing.hero.currentPage': 'Tuition & Benefits',
  'pricing.hero.imgAlt': 'A refined still life of butler tools and accessories',
  'pricing.hero.title': 'Tuition & Benefits',
  'pricing.hero.lead': 'Course fees include tuition, textbooks, practicum costs, enrollment gifts, and the final examination fee — all in one all-inclusive price.',

  // breadcrumb (page.tsx)
  'pricing.breadcrumb.home': 'Home',
  'pricing.breadcrumb.current': 'Tuition & Benefits',

  // PricingTable
  'pricing.table.label': 'TUITION TABLE',
  'pricing.table.title': 'Course Tuition at a Glance',
  'pricing.table.titleEn': 'Course Tuition',
  'pricing.table.lead': 'All course fees are all-inclusive — covering tuition, textbooks, practicum costs, enrollment benefits, and the final examination fee. Every course is quoted inclusive of tax.',
  'pricing.table.colItem': 'Item',
  'pricing.table.rowDuration': 'Duration',
  'pricing.table.rowDays': 'Days',
  'pricing.table.rowHours': 'Hours',
  'pricing.table.rowSchedule': 'Session',
  'pricing.table.rowPrice': 'Tuition (tax incl.)',
  'pricing.table.taxIncluded': '(tax incl.)',
  'pricing.table.courseListLink': 'course overview',
  'pricing.table.courseListNote': 'For full details on each course, visit our',
  'pricing.table.courseListNoteSuffix': '.',

  // WhatIncluded
  'pricing.included.label': "WHAT'S INCLUDED",
  'pricing.included.title': 'What the Tuition Covers',
  'pricing.included.titleEn': 'All-Inclusive Tuition',
  'pricing.included.lead': 'Every element of your learning is covered in the course fee — textbooks, practicum, enrollment gifts, and the final examination. There are no hidden costs.',
  'pricing.included.additionalTitle': 'Additional Costs',
  'pricing.included.imgAlt': 'The butler tool set included with enrollment',
  'pricing.included.imgCaption': 'Complete butler tool set provided with enrollment',

  // PaymentMethod
  'pricing.payment.label': 'PAYMENT',
  'pricing.payment.title': 'Payment Method',
  'pricing.payment.bankTitle': 'Bank Transfer (Single Payment Only)',
  'pricing.payment.bankInfo1': 'Tuition is payable by bank transfer in a single lump-sum payment.',
  'pricing.payment.bankInfo2': 'Full bank account details will be provided in the enrollment agreement sent after your application is received.',
  'pricing.payment.deadlineLabel': 'Payment Deadline',
  'pricing.payment.warningNote': 'Instalment plans and credit card payments are not accepted. Bank transfer fees are the responsibility of the applicant.',

  // TransferDiscount
  'pricing.transfer.label': 'TRANSFER BENEFIT',
  'pricing.transfer.title': 'Lateral Enrollment Discount',
  'pricing.transfer.taxNote': 'tax incl.',
  'pricing.transfer.consultLink': 'free consultation',
  'pricing.transfer.consultNote': 'For enquiries about lateral enrollment, please contact us via our',
  'pricing.transfer.consultNoteSuffix': '.',

  // MoreDetails
  'pricing.more.label': 'DETAILS',
  'pricing.more.title': 'Explore Further',
  'pricing.more.titleEn': 'Learn More',
  'pricing.more.lead': 'For detailed tuition breakdowns, enrollment benefits, and certification information, visit the individual pages below. Our team is happy to answer any questions during a free individual consultation.',
  'pricing.more.imgAlt': 'An instructor guiding a student through a table-setting practicum',
  'pricing.more.imgCaption': 'Practical instruction in progress',
  'pricing.more.arrowLabel': 'Learn more',

  // CTASection
  'pricing.cta.label': 'NEXT STEP',
  'pricing.cta.title': 'Start with a Free Brochure',
  'pricing.cta.lead': 'Request our free brochure to receive a detailed overview of our courses and the academy\'s educational philosophy. For further questions, our team is available for a complimentary individual consultation.',
  'pricing.cta.note': '* Online consultations are also available.',
  'pricing.cta.brochureBtn': 'Request a Brochure (Free)',
  'pricing.cta.consultBtn': 'Book a Consultation',
  'pricing.cta.corporateNote': 'Considering this for your company or organisation?',
  'pricing.cta.corporateLink': 'See our on-site corporate training',

  // FAQSection
  'pricing.faq.label': 'FAQ',
  'pricing.faq.title': 'Frequently Asked Questions',
  'pricing.faq.titleEn': 'Frequently Asked Questions',
  'pricing.faq.contactNote': 'For further enquiries, please use our',
  'pricing.faq.contactLink': 'contact form',
  'pricing.faq.contactNoteSuffix': '.',

  // RelatedPages
  'pricing.related.label': 'LEARN MORE',
  'pricing.related.title': 'Related Pages',
  'pricing.related.titleEn': 'Explore Further',
  'pricing.related.arrowLabel': 'Learn more',

  // footer
  'pricing.footer.lastUpdated': 'Last updated: 13 June 2026',
  'pricing.backToTop.ariaLabel': 'Back to top',

  // pricingCourses (mock data rows)
  'pricing.course.0.name': 'Essential Course',
  'pricing.course.0.duration': '1 Month',
  'pricing.course.0.days': '8 Days',
  'pricing.course.0.hours': '48 Hours',
  'pricing.course.0.schedule': 'July & December',
  'pricing.course.1.name': 'Advanced Course',
  'pricing.course.1.duration': '2 Months',
  'pricing.course.1.days': '12 Days',
  'pricing.course.1.hours': '72 Hours',
  'pricing.course.1.schedule': 'May–June & November–December',
  'pricing.course.2.name': 'Master Course',
  'pricing.course.2.duration': '3 Months',
  'pricing.course.2.days': '16 Days',
  'pricing.course.2.hours': '96 Hours',
  'pricing.course.2.schedule': 'February–April & September–November',

  // whatIncluded items
  'pricing.included.0.label': 'Tuition',
  'pricing.included.0.desc': 'Common to all courses. Face-to-face instruction and practical guidance from our experienced teaching staff.',
  'pricing.included.1.label': 'Textbooks',
  'pricing.included.1.desc': 'Association-supervised specialist textbooks: 5 volumes for Essential, 10 for Advanced, and all 15 for Master.',
  'pricing.included.2.label': 'Practicum',
  'pricing.included.2.desc': 'Role-play practicum sessions in the academy studio. Advanced and Master courses include a special experiential practicum.',
  'pricing.included.3.label': 'Enrollment Gifts',
  'pricing.included.3.desc': 'Butler tool set, white gloves, custom-made vest (Master), and career support for graduates (in preparation), among others.',
  'pricing.included.4.label': 'Final Practical Examination',
  'pricing.included.4.desc': 'Practical examination conducted at the end of each course. Successful candidates receive the Association certification.',
  'pricing.included.5.label': 'White Gloves',
  'pricing.included.5.desc': 'High-quality white gloves provided as standard across all courses. Worn from the very first day of service practicum.',

  // additionalCosts
  'pricing.additionalCosts.0': 'Bank transfer fees are the responsibility of the applicant.',
  'pricing.additionalCosts.1': 'Travel expenses to the special practicum venue (Advanced & Master) are borne by the participant.',
  'pricing.additionalCosts.2': 'No further charges are incurred as a general rule.',

  // paymentMethod
  'pricing.paymentMethod.lead': 'Payment is accepted by bank transfer (lump-sum) only. Full bank account details will be provided in the enrollment agreement sent after your application is received. Instalment plans and credit card payments are not accepted.',
  'pricing.paymentMethod.deadline': '14 days before the course start date',
  'pricing.paymentMethod.note.0': 'Bank transfer fees are the responsibility of the applicant.',
  'pricing.paymentMethod.note.1': 'Enrollment is confirmed once payment has been received.',
  'pricing.paymentMethod.note.2': 'Instalment plans and credit card payments are not accepted.',

  // transferDiscount
  'pricing.transfer.lead': 'The Advanced Course includes the full content of Essential, and the Master Course includes the full content of both Essential and Advanced, so we offer a reduction for the overlapping content already completed. \n\nThe more courses you complete in sequence, the more you save overall.',
  'pricing.transfer.0.from': 'Essential Course',
  'pricing.transfer.0.to': 'Advanced Course',
  'pricing.transfer.0.desc': 'As the Advanced Course includes the full content of Essential, graduates of the Essential Course who advance to the Advanced Course receive a JPY 80,000 (tax incl.) reduction on the Advanced Course fee for the overlapping content.',
  'pricing.transfer.1.from': 'Advanced Course',
  'pricing.transfer.1.to': 'Master Course',
  'pricing.transfer.1.desc': 'As the Master Course includes the full content of Advanced, graduates of the Advanced Course who advance to the Master Course receive a JPY 180,000 (tax incl.) reduction on the Master Course fee for the overlapping content.',

  // moreDetails
  'pricing.moreDetails.0.title': 'Detailed Tuition Breakdown',
  'pricing.moreDetails.0.desc': 'Explore the full line-item breakdown of what each course fee covers.',
  'pricing.moreDetails.1.title': 'Enrollment Benefits',
  'pricing.moreDetails.1.desc': 'Details on the practical enrollment gifts included with your course.',
  'pricing.moreDetails.2.title': 'Completion Certificate & Certification',
  'pricing.moreDetails.2.desc': 'Learn about the Association certification awarded upon completion.',

  // pricingFaqs
  'pricing.faq.0.q': 'How much does each course cost?',
  'pricing.faq.0.a': 'Essential Course: JPY 780,000 / Advanced Course: JPY 1,180,000 / Master Course: JPY 1,680,000 (all prices tax inclusive).',
  'pricing.faq.1.q': 'What does the fee include?',
  'pricing.faq.1.a': 'Tuition, textbooks, practicum, enrollment gifts, the final practical examination fee, and white gloves are all included. No additional costs as a general rule.',
  'pricing.faq.2.q': 'How can I pay?',
  'pricing.faq.2.a': 'Bank transfer (lump-sum) only. Instalment plans and credit card payments are not accepted.',
  'pricing.faq.3.q': 'Can I pay in instalments?',
  'pricing.faq.3.a': 'We are sorry, but payment is by bank transfer in full only; instalment payments and credit cards are not accepted. Payment is due 14 days before the course start date.',
  'pricing.faq.4.q': 'Is there a transfer discount?',
  'pricing.faq.4.a': 'Yes. When progressing from Essential to Advanced, JPY 80,000 (tax incl.) is deducted from the Advanced fee; from Advanced to Master, JPY 180,000 (tax incl.) is deducted from the Master fee.',
  'pricing.faq.5.q': 'Are there any costs beyond the course fee?',
  'pricing.faq.5.a': 'Bank transfer fees are payable by the student. In addition, for the special practicum in the Advanced and Master courses (experiencing real service first-hand), travel costs to the venue are borne by each participant. \n\nAs a general rule, no other costs apply.',
  'pricing.faq.6.q': 'When do the courses start?',
  'pricing.faq.6.a': 'The Essential Course starts in July and December, the Advanced Course in May–June and November–December, and the Master Course in February–April and September–November. All are held on weekends, six hours per day (four 90-minute sessions). \n\nApplications close 14 days before the start date.',
  'pricing.faq.7.q': 'Is there a class-size limit or a minimum number to run a course?',
  'pricing.faq.7.a': 'Yes. Each course is a strictly small-group format with a maximum of six students. \n\nThe minimum required to run a course is three; if three students are not reached by 14 days before the start date, you may choose a full refund of the course fee or a transfer to the next term (with a 5% preferential discount).',

  // pricingRelatedPages
  'pricing.related.0.title': 'Detailed Tuition Breakdown',
  'pricing.related.0.desc': 'Full breakdown of each course fee',
  'pricing.related.1.title': 'Enrollment Benefits',
  'pricing.related.1.desc': 'Practical enrollment gifts',
  'pricing.related.2.title': 'Completion Certificate & Certification',
  'pricing.related.2.desc': 'Association certification earned upon completion',
  'pricing.related.3.title': 'Courses Overview',
  'pricing.related.3.desc': 'Compare all three courses at a glance',
};

export default pricing;
